export type TDvsErrorDetail = {
  field?: string;
  source?: string;
  message?: string;
};

export type TDvsStatusWithErrorDetails = {
  status?: keyof typeof TDocumentVerificationStatus;
  errorDetails?: TDvsErrorDetail[];
};

export type TDocumentVerificationStatusActions = Omit<
  typeof TDocumentVerificationStatus,
  'Pending' | 'SystemError'
>;

export enum TDocumentVerificationStatus {
  Pending = 'Pending',
  Passed = 'Passed',
  Failed = 'Failed',
  SystemError = 'SystemError',
  DataError = 'DataError',
}
